<script>
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import { usePageMerchAboLad } from "@/components/pages/mixins/merch-abo-lad";

import coraplusLogo from "@/assets/images/abonnement/coraplus/coraplus-logo.svg";

export default {
  name: "AbonnementLadtuile",
  components: { Card, Button, LazyImage, HtmlParser },
  props: {
    imgPath: {
      type: String,
      required: false,
      default: null
    },
    imgWidth: {
      type: [String, Number],
      required: false,
      default: null
    },
    imgHeight: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  setup() {
    const { aboladcodes, getAboLadData, merchAboLad } = usePageMerchAboLad();
    return {
      aboladcodes,
      getAboLadData,
      merchAboLad,
      coraplusLogo
    };
  }
};
</script>
<template>
  <Card class="c-abonnement-lad-tuile">
    <div class="c-abonnement-lad-tuile__content">
      <client-only>
        <HtmlParser
          v-if="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
          :content="getAboLadData(aboladcodes.DESCRIPTION_OFFRE_HTML)"
          class="u-mb-md"
        />
      </client-only>
      <div class="c-abonnement-lad-tuile__image-wrapper">
        <LazyImage
          :src="imgPath"
          :width="imgWidth"
          :height="imgHeight"
          alt=""
          class=""
        />
      </div>
      <div class="c-abonnement-lad-tuile__text">
        <LazyImage
          :src="coraplusLogo"
          height="24"
          alt="coraplus"
          class="c-abonnement-lad-tuile__logo"
        />
        <p class="u-font-700">
          Le nouveau service de livraison
        </p>
        <client-only>
          <HtmlParser
            v-if="getAboLadData(aboladcodes.DESCRIPTION)"
            class="u-font-14 u-font-500 u-mt-xs"
            :content="getAboLadData(aboladcodes.DESCRIPTION)"
          />
          <p
            v-else
            class="u-font-14 u-font-500 u-mt-xs"
          >
            Faites-vous livrer tous les jours si vous le voulez*
          </p>
        </client-only>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          class="c-abonnement-lad-tuile__call-to"
          to="/abonnement-livraison"
        >
          Je découvre les formules
        </Button>
        <client-only>
          <div class="c-abonnement-lad-tuile__condition">
            {{ getAboLadData(aboladcodes.MENTION_LEGALE) ? 
              getAboLadData(aboladcodes.MENTION_LEGALE):
              "*Sous réserve d'un créneau de livraison disponible ainsi qu'à l'exception des dimanches et jours fériés." }}
          </div>
        </client-only>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/abonnement-lad-tuile.scss";
</style>
